<template>
  <div class="title ljb-big-title flex ljb-double_center">
    {{ moduleTitle.title }}
    <span
      v-show="moduleTitle.text"
      class="text"
      @click="goLink(moduleTitle.url)">{{ moduleTitle.text }}</span>
  </div>
</template>
<script>
export default {
  name: 'ModuleTitle',
  props: {
    moduleTitle: {
      type: Object,
      default: function () {
        return ''
      }
    }
  },
  methods: {
    goLink(url) {
      this.$router.push(url)
    }
  },
}
</script>

<style lang="scss" scoped>
  .title{
    // margin-top: $margin;
    padding:  $padding;
    position: relative;
    .text{
      margin-left: 10px;
      font-size: 12px;
      color: #999999;
      position: absolute;
      right: $padding;
      top: $padding;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/title/ModuleTitleNew.vue